/**
 * Kasa uygulamasının yayın bilgisi — `download.cafeotomasyonu.com` (R2).
 *
 * Sayfa `release.json`u okuyor (sürüm, boyut, not); okuyamazsa SABİT
 * adreslere düşüyor. Sabit adres her zaman son sürümü indiriyor
 * (`publish.mjs` her yayında onu yeniliyor), yani `release.json`a
 * ulaşılamaması indirmeyi engellemiyor, yalnızca sürüm numarası görünmüyor.
 * Tersi — bilgi gelmeden düğme çizmemek — CORS ayarındaki tek bir hatanın
 * vitrinden indirmeyi tamamen kaldırması demekti.
 */

export const DOWNLOAD_BASE = 'https://download.cafeotomasyonu.com/kasa/stable';

export const FALLBACK_DOWNLOADS = {
  windows: { stableUrl: `${DOWNLOAD_BASE}/Cafeotomasyonu-Kasa-Setup.exe` },
  mac: { stableUrl: `${DOWNLOAD_BASE}/Cafeotomasyonu-Kasa-mac.dmg` },
};

/** Ziyaretçinin işletim sistemi — yalnızca hangi düğmenin ÖNDE olacağı için. */
export function detectPlatform(nav = typeof navigator !== 'undefined' ? navigator : {}) {
  const hint = `${nav.userAgentData?.platform || ''} ${nav.platform || ''} ${nav.userAgent || ''}`.toLowerCase();
  if (/android|iphone|ipad|ipod/.test(hint)) return 'mobile';
  if (/mac/.test(hint)) return 'mac';
  if (/win/.test(hint)) return 'windows';
  return 'other';
}

export function formatSize(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return null;
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}

export function formatReleaseDate(iso) {
  const date = iso ? new Date(iso) : null;
  if (!date || Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
}

/**
 * `release.json`u okur. Hata FIRLATMIYOR — `null` dönüyor ve sayfa sabit
 * adreslerle çalışmaya devam ediyor.
 */
export async function fetchDesktopRelease(fetchImpl = fetch) {
  try {
    const response = await fetchImpl(`${DOWNLOAD_BASE}/release.json`, { cache: 'no-store' });
    if (!response.ok) return null;
    const manifest = await response.json();
    return manifest && manifest.version ? manifest : null;
  } catch {
    return null;
  }
}
